export const optionsNewsType = [
  { key: "berita", label: "News & Ads" },
  { key: "edukasi", label: "Education" },
];
